import type { ChangeEvent } from 'react';
import { useEffect } from 'react';

import { useTypedSearchParams } from '.';
import { useDebouncedState } from '../useDebouncedState';

const useKeywordSearchParam = ({
  searchParamKey,
}: {
  searchParamKey: string;
}) => {
  const { get, set, remove, flush } = useTypedSearchParams<{
    [searchParamKey]: string;
  }>();

  const initialValue = get(searchParamKey) ?? '';
  const {
    state: keyword,
    debouncedState: debouncedKeyword,
    onChange,
  } = useDebouncedState(initialValue, 500);

  useEffect(() => {
    if (debouncedKeyword) {
      set(searchParamKey, debouncedKeyword);
    } else {
      remove(searchParamKey);
    }
    flush();
  }, [debouncedKeyword, searchParamKey, set, remove, flush]);

  const onKeywordChange = (e: ChangeEvent<HTMLInputElement>) => {
    const keyword = e.target.value;
    onChange(keyword);
  };

  return {
    onKeywordChange,
    keyword,
  };
};

export default useKeywordSearchParam;
